import { Link, useParams } from "react-router-dom"
import DashboardSideBar from "../../components/dashboardSidebar"
import Footer from "../../components/footer"
import Header from "../../components/header"
import SideBar from "../../components/sidebar"
import { useState, useEffect } from "react"
import services from "../../services"
import Toaster from "../../components/toaster";
import moment from 'moment'
import useIsMobile from "../../hooks/useIsMobile";
import MobileHeader from "../../components/MobileHeader";

const SubscriptionDetail = () => {
    const { id } = useParams();
    const isMobileView = useIsMobile();
    const [subscriptionData, setSubscriptionData] = useState(null)
    const [toaster, setToaster] = useState({ visiblity: "hide" });
    const [loading, setLoading] = useState(true)

    const getSubscriptionDetails = async () => {
        setLoading(true)
        try {
            const response = await services.Vendor.GET_VENDOR_SUBSCRIPTION_BY_ID(id);
            setSubscriptionData(response.data)
        } catch (error) {
            console.log(error)
            setToaster({
                type: "danger",
                title: "Error Occured",
                text: error.response?.data?.message || "Failed to fetch subscription details",
                visiblity: "show",
            });
            setTimeout(() => {
                setToaster({ visiblity: "hide" });
            }, 1500)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            getSubscriptionDetails()
        }
    }, [id])

    if (isMobileView) {
        if (loading) {
            return (<main className="mlux" style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}><div className="mlux-empty"><div className="ic"><i className="far fa-spinner"></i></div><h4>Loading…</h4></div></main>);
        }
        if (!subscriptionData) {
            return (<main className="mlux mlux-auth"><MobileHeader back="/subscriptions" /><div className="mlux-card mlux-empty" style={{ marginTop: 20 }}><div className="ic"><i className="far fa-id-badge"></i></div><h4>Not found</h4><p>This subscription could not be loaded.</p><Link to="/subscriptions" className="mlux-btn ghost" style={{ textDecoration: 'none' }}>Back to subscriptions</Link></div></main>);
        }
        const s = subscriptionData;
        return (
            <>
                <Toaster type={toaster.type} title={toaster.title} text={toaster.text} visiblity={toaster.visiblity} />
                <SideBar />
                <main className="mlux mlux-auth">
                    <MobileHeader back="/subscriptions" right={<span className="mlux-pill" style={{ background: s.isActive ? 'rgba(22,163,74,0.12)' : 'rgba(239,68,68,0.12)', color: s.isActive ? '#16a34a' : '#ef4444' }}>{s.isActive ? 'Active' : 'Inactive'}</span>} />
                    <div className="mlux-greet" style={{ margin: '8px 4px 2px' }} data-rise="1">
                        <div className="kick">Subscription</div>
                        <div className="nm" style={{ fontSize: 22 }}>#{s.id}</div>
                    </div>
                    <div className="mlux-card mlux-fare" data-rise="1">
                        <div className="r tot" style={{ borderTop: 0, marginTop: 0, paddingTop: 0 }}><span className="lbl">Total cost</span><span className="amt">Rs. {s.totalCost?.toLocaleString('en-IN')}</span></div>
                    </div>
                    <div className="mlux-sec-head"><h3>Details</h3></div>
                    <div className="mlux-card" style={{ padding: '4px 16px' }} data-rise="2">
                        <div className="mlux-kv"><span className="k"><i className="far fa-calendar"></i> Start date</span><span className="v">{moment(s.startDate).format('DD MMM YY')}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-calendar-check"></i> End date</span><span className="v">{moment(s.endDate).format('DD MMM YY')}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-credit-card"></i> Payment mode</span><span className="v" style={{ textTransform: 'capitalize' }}>{s.modeOfPayment || 'N/A'}</span></div>
                        <div className="mlux-kv"><span className="k"><i className="far fa-clock"></i> Created</span><span className="v">{moment(s.createdAt).format('DD MMM YY')}</span></div>
                    </div>
                </main>
            </>
        );
    }

    if (loading) {
        return (<>
            <Header />
            <SideBar />
            <main class="main">
                <div class="user-profile py-5">
                    <div class="container">
                        <div class="row">
                            <DashboardSideBar />
                            <div class="col-lg-9">
                                <div class="text-center py-5">
                                    <p>Loading subscription details...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>)
    }

    if (!subscriptionData) {
        return (<>
            <Header />
            <SideBar />
            <main class="main">
                <div class="user-profile py-5">
                    <div class="container">
                        <div class="row">
                            <DashboardSideBar />
                            <div class="col-lg-9">
                                <div class="text-center py-5">
                                    <p>Subscription not found</p>
                                    <Link to={'/subscriptions'} class="theme-btn">Back to Subscriptions</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </>)
    }

    return (<>
        <Header />
        <SideBar />
        <main class="main">
            <Toaster
                type={toaster.type}
                title={toaster.title}
                text={toaster.text}
                visiblity={toaster.visiblity}
            />

            <div class="user-profile py-5">
                <div class="container">
                    <div class="row">
                        <DashboardSideBar />
                        <div class="col-lg-9">
                            <div class="user-profile-wrapper">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="user-profile-card">
                                            <div class="user-profile-card-header">
                                                <h4 class="user-profile-card-title">Subscription Details</h4>
                                                <div class="user-profile-card-header-right">
                                                    {/* <Link to={`/subscriptions/edit/${id}`} class="theme-btn">
                                                        <i class="far fa-pencil"></i> Edit
                                                    </Link> */}
                                                </div>
                                            </div>
                                            <div class="user-profile-form">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Start Date</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={moment(subscriptionData.startDate).format('DD-MM-YYYY, hh:mm A')}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>End Date</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={moment(subscriptionData.endDate).format('DD-MM-YYYY, hh:mm A')}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Total Cost</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={`Rs. ${subscriptionData.totalCost?.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Mode of Payment</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={subscriptionData.modeOfPayment ? subscriptionData.modeOfPayment.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : 'N/A'}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Status</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={subscriptionData.isActive ? 'Active' : 'Inactive'}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Created Date</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={moment(subscriptionData.createdAt).format('DD-MM-YYYY, hh:mm A')}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Updated Date</label>
                                                            <input
                                                                type="text"
                                                                class="form-control"
                                                                value={moment(subscriptionData.updatedAt).format('DD-MM-YYYY, hh:mm A')}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center gap-3">
                                                    <Link to={'/subscriptions'} class="theme-btn my-3" style={{ background: '#6c757d' }}>
                                                        <span class="far fa-arrow-left"></span> Back to List
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </main>
        <Footer />
    </>
    )
}
export default SubscriptionDetail

